import { useEffect, useState } from "react";

import { getEvents } from "../api/api";
import { Button } from "../components/Button";

function eventKindLabel(kind) {
  return kind === "tournament" ? "Турнир" : "Мероприятие";
}

export function Events({ onBack }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [openedTournamentId, setOpenedTournamentId] = useState(null);

  const canOpenTournamentParticipants = (event) => {
    if (event?.kind !== "tournament") return false;
    const isoDate = String(event?.date || "").trim();
    const isoTime = String(event?.time || "").trim();
    if (!isoDate || !isoTime) return false;
    const startsAt = new Date(`${isoDate}T${isoTime.length === 5 ? `${isoTime}:00` : isoTime}`);
    if (Number.isNaN(startsAt.getTime())) return false;
    return startsAt.getTime() > Date.now();
  };

  const canOpenTournamentPanel = (event) => {
    if (event?.kind !== "tournament") return false;
    return canOpenTournamentParticipants(event) || Boolean(event?.tournament_bracket);
  };

  const renderGuestTournamentMatch = (match) => {
    const p1 = match?.player1;
    const p2 = match?.player2;
    const isDone = match?.status === "completed" || match?.status === "bye";
    const winnerName =
      Number(match?.winner_user_id) === Number(p1?.user_id)
        ? p1?.full_name
        : Number(match?.winner_user_id) === Number(p2?.user_id)
          ? p2?.full_name
          : null;
    return (
      <div key={match.id} className="tournamentMatchCard">
        <p className="muted tournamentMatchCard__title">Матч {match.id}</p>
        <p className="muted tournamentMatchCard__players">
          {p1?.full_name || "TBD"} vs {p2?.full_name || "TBD"}
        </p>
        {isDone ? (
          <p className="muted">Победитель: {winnerName || "определён"}</p>
        ) : null}
      </div>
    );
  };

  const toggleTournamentParticipants = (event) => {
    if (!canOpenTournamentPanel(event)) return;
    setOpenedTournamentId((prev) => (prev === event.id ? null : event.id));
  };

  useEffect(() => {
    let mounted = true;
    getEvents()
      .then((data) => {
        if (!mounted) return;
        setItems(data);
      })
      .catch((err) => {
        if (!mounted) return;
        setError(err?.message || "Не удалось загрузить мероприятия");
      })
      .finally(() => {
        if (!mounted) return;
        setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <section className="client">
      <header className="sectionHeader">
        <h2>Мероприятия</h2>
        <p>Актуальные ивенты.</p>
      </header>

      <div className="eventsToolbar">
        <Button onClick={onBack}>Назад</Button>
      </div>

      {loading ? <p className="muted">Загрузка...</p> : null}
      {!loading && error ? <p className="errorMessage">{error}</p> : null}

      {!loading && !error ? (
        <div className="eventsList">
          {items.length === 0 ? (
            <p className="muted">Пока мероприятий нет.</p>
          ) : (
            items.map((event) => (
              <article
                key={event.id}
                className={`eventsItem ${
                  canOpenTournamentPanel(event) ? "eventsItem--clickable" : ""
                }`}
                onClick={() => toggleTournamentParticipants(event)}
                onKeyDown={(e) => {
                  if (!canOpenTournamentPanel(event)) return;
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    toggleTournamentParticipants(event);
                  }
                }}
                role={canOpenTournamentPanel(event) ? "button" : undefined}
                tabIndex={canOpenTournamentPanel(event) ? 0 : undefined}
              >
                <p className="muted">{eventKindLabel(event.kind)}</p>
                <h3>{event.title}</h3>
                <p className="eventsMeta">{event.date} · {event.time}</p>
                {event.image_url ? (
                  <div className="eventsImage">
                    <img src={event.image_url} alt={event.title} />
                  </div>
                ) : null}
                <p>{event.description}</p>
                {canOpenTournamentPanel(event) ? (
                  <div className="eventsTournamentPanel">
                    <p className="muted">
                      {openedTournamentId === event.id
                        ? "Скрыть турнирные детали"
                        : "Показать турнирные детали"}
                    </p>
                    {openedTournamentId === event.id ? (
                      <>
                        {event.tournament_bracket ? (
                          <div className="tournamentBracket">
                            <p className="muted">Статус сетки: {event.tournament_bracket.status}</p>
                            <div className="tournamentBracket__columns">
                              {Array.isArray(event.tournament_bracket.winner_rounds) &&
                              event.tournament_bracket.winner_rounds.length > 0 ? (
                                <div className="tournamentBracket__column">
                                  <h4>Верхняя сетка</h4>
                                  {event.tournament_bracket.winner_rounds.map((round) => (
                                    <div key={`GW_${round.round_index}`} className="tournamentBracket__round">
                                      <p className="muted">Раунд W{round.round_index}</p>
                                      {(round.matches || []).map((m) => renderGuestTournamentMatch(m))}
                                    </div>
                                  ))}
                                </div>
                              ) : null}
                              {Array.isArray(event.tournament_bracket.loser_rounds) &&
                              event.tournament_bracket.loser_rounds.length > 0 ? (
                                <div className="tournamentBracket__column">
                                  <h4>Нижняя сетка</h4>
                                  {event.tournament_bracket.loser_rounds
                                    .filter((r) => Number(r.round_index) > 0)
                                    .map((round) => (
                                      <div key={`GL_${round.round_index}`} className="tournamentBracket__round">
                                        <p className="muted">Раунд L{round.round_index}</p>
                                        {(round.matches || []).map((m) => renderGuestTournamentMatch(m))}
                                      </div>
                                    ))}
                                </div>
                              ) : null}
                              <div className="tournamentBracket__column">
                                <h4>Финалы</h4>
                                {event.tournament_bracket.grand_final ? (
                                  <div className="tournamentBracket__round">
                                    <p className="muted">Гранд-финал</p>
                                    {renderGuestTournamentMatch(event.tournament_bracket.grand_final)}
                                  </div>
                                ) : (
                                  <p className="muted">Гранд-финал еще не сформирован.</p>
                                )}
                                {event.tournament_bracket.third_place ? (
                                  <div className="tournamentBracket__round">
                                    <p className="muted">Матч за 3 место</p>
                                    {renderGuestTournamentMatch(event.tournament_bracket.third_place)}
                                  </div>
                                ) : (
                                  <p className="muted">Матч за 3 место еще не сформирован.</p>
                                )}
                              </div>
                            </div>
                          </div>
                        ) : null}
                        {Array.isArray(event.tournament_participants) &&
                        event.tournament_participants.length > 0 ? (
                          <ul className="eventsTournamentList">
                            {event.tournament_participants.map((participant) => (
                              <li key={`${event.id}:${participant.user_id}`}>{participant.full_name}</li>
                            ))}
                          </ul>
                        ) : (
                          <p className="muted">Список участников пока пуст.</p>
                        )}
                      </>
                    ) : null}
                  </div>
                ) : null}
              </article>
            ))
          )}
        </div>
      ) : null}
    </section>
  );
}
